import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Vendor, VendorQuotaUpdate } from '@api/models/dashboard';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VendorsData extends ApiServiceBase<Vendor> {
  constructor() {
    super('vendors', 'evoqAdmin');
  }

  fetchVendors(storeId: string): Observable<Vendor[]> {
    this.endpoint = `${storeId}/vendors`;
    return this.list();
  }

  updateQuotas(storeId: string, updates: VendorQuotaUpdate[]): Observable<Vendor[]> {
    this.endpoint = `${storeId}/vendors`;
    return this.customRequest<Vendor[]>({
      method: 'PATCH',
      url: 'quotas',
      body: updates,
    });
  }
}
